<template>
  <div id="export">
    <h6 class="page-title">Report Export & History</h6>
    <div class="retention-guide">
      <p class="mb-5">The recently submitted Action Plan, the Dealer Assessment Report and the Technician Retention Guide sections related to the chosen Top Improvement Priority are highlighted.  Click to choose and download your preferred tools to create a customized and consolidated plan for the dealership. For more research, data, suggestions and tips on proven practices to implement, download the selected or specific sections of the Technician Retention Guide.</p>
    </div>
    <div class="action-plan mt-5">
      <div class="row">
        <div class="col-md-12">
          <h6 class="action-plan-header mb-3">Technician Retention Dealer Tools</h6>
          <div class="dealer-tools">
            <div>
              <b-button class="link-button mr-5" @click="selectAll" variant="link" :disabled="!recentAssessment">Select All</b-button>
              <b-button class="link-button" @click="clearAll" variant="link" :disabled="!recentAssessment">Clear All</b-button>
            </div>
            <div class="mt-3 guide-button-container">
              <h6 class="page-title">Dealer Reports</h6>
              <b-button class="dealer-tool-button selected" @click="selectGuide($event, 'cover')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('cover')"></selected-icon>
                Cover Page
              </b-button>
              <b-button class="dealer-tool-button selected" @click="selectGuide($event, 'overview')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('overview')"></selected-icon>
                Assessment Overview
              </b-button>
              <b-button class="dealer-tool-button selected" @click="selectGuide($event, 'highlights')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('highlights')"></selected-icon>
                Dealership Assessment
              </b-button>
              <b-button class="dealer-tool-button selected" @click="selectGuide($event, 'recent_plan')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('recent_plan')"></selected-icon>
                Action Plan
              </b-button>
            </div>
            <div class="mt-2 guide-button-container">
              <h6 class="page-title">Technician Retention Guide Sections</h6>
              <!--              <b-button id="assessment_report_button" class="dealer-tool-button selected" @click="selectGuide($event, 'assessment_report')" pill>-->
              <!--                <selected-icon isSelected></selected-icon>-->
              <!--                Assessment Report-->
              <!--              </b-button>-->
              <b-button id="introduction_button" class="dealer-tool-button selected" @click="selectGuide($event, 'introduction')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('introduction')"></selected-icon>
                Introduction
              </b-button>
              <b-button id="compensation_button" v-bind:class="{ selected: this.selectedGuides.includes('compensation') }" class="dealer-tool-button" @click="selectGuide($event, 'compensation')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('compensation')"></selected-icon>
                Compensation
              </b-button>
              <b-button id="training_button" v-bind:class="{ selected: this.selectedGuides.includes('training') }" class="dealer-tool-button" @click="selectGuide($event, 'training')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('training')"></selected-icon>
                Training
              </b-button>
              <b-button id="management_button" v-bind:class="{ selected: this.selectedGuides.includes('management') }" class="dealer-tool-button" @click="selectGuide($event, 'management')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('management')"></selected-icon>
                Management
              </b-button>
              <b-button id="dealer_conditions_button" v-bind:class="{ selected: this.selectedGuides.includes('dealer_conditions') }" class="dealer-tool-button" @click="selectGuide($event, 'dealer_conditions')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('dealer_conditions')"></selected-icon>
                Dealer Conditions
              </b-button>
              <b-button id="rewards_&_recognition_button" v-bind:class="{ selected: this.selectedGuides.includes('rewards') }" class="dealer-tool-button" @click="selectGuide($event, 'rewards')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('rewards')"></selected-icon>
                Rewards & Recognition
              </b-button>
              <b-button id="conclusion_button" class="dealer-tool-button selected" @click="selectGuide($event, 'conclusion')" pill :disabled="!recentAssessment">
                <selected-icon :isSelected="this.selectedGuides.includes('conclusion')"></selected-icon>
                Conclusion
              </b-button>
            </div>

            <div class="mt-4">
              <b-button v-if="recentAssessment" class="retention-guide-btn" pill @click="downloadAssessmentPlan(recentAssessment.id)" :disabled="busy">
                {{ this.busy ? `Downloading (${this.percentCompleted}%)` : "Generate Dealer Report" }}
              </b-button>
              <b-button v-else  class="retention-guide-btn" pill :disabled="!recentAssessment">
                Generate Dealer Report
              </b-button>
            </div>
          </div>
        </div>
        <div v-if="recentAssessment === null" class="col-md-12 mt-5">
          <span class="text-danger">There are no current reports to generate. Fill out the Assessment Form to begin a new session or view previously saved reports in the History log below.</span>
        </div>
        <div class="col-md-12 mt-5">
          <h6 class="action-plan-header mb-4">Dealer Report History</h6>
          <div class="dealer-actions-container">
            <div v-for="assessment in assessments" :key="`assessment-${assessment.id}`" class="dealer-action">
              <div class="action-date">
                <span>{{ format(new Date(assessment.updated_at), 'yyyy/MM/dd hh:mm:ss a') }}</span>
              </div>
              <div class="action-details">
                <h6>Retention Priority: {{ assessment.priority }}</h6>
<!--                <mq-layout mq="lg+">-->
                  <div class="row">

                    <div class="col-md-9">
                      {{ historySelectedGuides(assessment).join(", ") }}
<!--                      <truncate action-class="more-less-button" collapsed-text-class="collapsed" clamp="MORE" :length="147" less="Show Less" type="html" :text="assessment.action_plan || ''"></truncate>-->
                    </div>
                    <div class="col-md-3">
                      <b-button class="retention-guide-btn float-right" variant="link" @click="openAssessmentPlan(assessment.id)">Open Plan</b-button>
                    </div>
                  </div>
<!--                </mq-layout>-->
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import ApiService from "../services/api.service";
import Axios from "axios";
import { format } from 'date-fns';
import SelectedIcon from "./SelectedIcon";

export default {
  name: "report-export",
  props: {
  },
  components: {
    SelectedIcon,
  },
  data(){
    return {
      // selected: [],
      // planContent: null,
      percentCompleted: 0,
      recentAssessment: null,
      assessments: [],
      selectedGuides: ['assessment_report', 'introduction', 'conclusion', 'cover', 'overview', 'highlights', 'recent_plan'],
      busy: false
    }
  },
  created() {
    Promise.all([this.getRecentAssessment(), this.getAssessments()])
      .then((responses) => {
        const [recentAssessment, assessments] = responses.map(response => response.data);
        [this.recentAssessment] = recentAssessment;

        let filteredAssessments = assessments.filter(obj => {
          return obj.report_sections.length > 0
        })

        if (this.recentAssessment?.report_sections?.length > 0 || this.recentAssessment?.action_plan === null) {
          this.recentAssessment = null;
        }

        this.assessments = filteredAssessments

        this.selectDealerTools();
        this.loadPreviousSelections();
      })
  },
  methods: {
    historySelectedGuides(assessment) {
      let array = []

      if (assessment.report_sections.includes("cover")) array.push("Cover Page")
      if (assessment.report_sections.includes("overview")) array.push("Assessment Overview")
      if (assessment.report_sections.includes("highlights")) array.push("Dealership Assessment")
      if (assessment.report_sections.includes("recent_plan")) array.push("Action Plan")
      if (assessment.report_sections.includes("introduction")) array.push("Introduction")
      if (assessment.report_sections.includes("compensation")) array.push("Compensation")
      if (assessment.report_sections.includes("training")) array.push("Training")
      if (assessment.report_sections.includes("management")) array.push("Management")
      if (assessment.report_sections.includes("dealer_conditions")) array.push("Dealer Conditions")
      if (assessment.report_sections.includes("rewards")) array.push("Rewards & Recognition")
      if (assessment.report_sections.includes("conclusion")) array.push("Conclusion")

      return array
    },
    buildURLParams(sections) {
      let params = ""
      let guides = []

      if (sections) {
        guides = sections;
      } else {
        guides = this.selectedGuides;
      }

      if (guides.includes("cover")) {
        params += "cover=true&"
      }
      if (guides.includes("overview")) {
        params += "overview=true&"
      }
      if (guides.includes("highlights")) {
        params += "highlights=true&"
      }
      if (guides.includes("recent_plan")) {
        params += "recent_plan=true&"
      }

      if (guides.includes("introduction")) {
        params += "introduction=true&"
      }
      if (guides.includes("compensation")) {
        params += "compensation=true&"
      }
      if (guides.includes("training")) {
        params += "training=true&"
      }
      if (guides.includes("management")) {
        params += "management=true&"
      }
      if (guides.includes("dealer_conditions")) {
        params += "dealer_conditions=true&"
      }
      if (guides.includes("rewards")) {
        params += "rewards=true&"
      }
      if (guides.includes("conclusion")) {
        params += "conclusion=true&"
      }

      return params;
    },
    loadPreviousSelections() {
      if (this.recentAssessment === null) return;

      ApiService.get('api/v1/assessments', this.recentAssessment.id)
        .then(({ data }) => {
          if (data.report_sections && data.report_sections.length > 0) {
            this.selectedGuides = data.report_sections;
          } else {
            switch (localStorage.getItem('priority')) {
              case "Compensation":
                this.selectedGuides.push("compensation");
                break;
              case "Management":
                this.selectedGuides.push("management");
                break;
              case "Training":
                this.selectedGuides.push("training");
                break;
              case "Dealer Conditions":
                this.selectedGuides.push("dealer_conditions");
                break;
              case "Rewards & Recognition":
                this.selectedGuides.push("rewards");
                break;
            }
          }
        })
    },
    openAssessmentPlan(id) {
      let assessment = this.assessments.filter(assessment => {
        return assessment.id === id
      })[0]

      let params = this.buildURLParams(assessment.report_sections);
      let url = `${process.env.VUE_APP_API_URL}api/v1/assessments/${id}/report.pdf?${params}`
      window.open(url, "_blank");
    },
    downloadAssessmentPlan(id) {
      this.busy = true

      let params = this.buildURLParams();

      let url = `${process.env.VUE_APP_API_URL}api/v1/assessments/${id}/report.pdf?${params}`
      let label = `${this.recentAssessment.dealership}-${new Date(this.recentAssessment.updated_at).toLocaleDateString("en-US")}-report`


      let assessmentReportParams = {
        assessment: {
          report_sections: this.selectedGuides,
        }
      }

      ApiService.update('api/v1/assessments', this.recentAssessment.id, assessmentReportParams)
        .then(() => {
          Axios.get(url, { responseType: 'blob', onDownloadProgress: progressEvent => {
            console.log(progressEvent);
              let currentProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              console.log('completed: ', currentProgress)
              this.percentCompleted = currentProgress;
            } })
            .then(response => {
              const blob = new Blob([response.data], { type: 'application/pdf' })
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = label
              link.click()
              URL.revokeObjectURL(link.href)
              this.getAssessments().then((data) => {
                this.assessments = data.data;
              });

              localStorage.removeItem('priority');
              this.recentAssessment = null;

              this.busy = false
              console.log("Done downloading")
            }).catch(console.error)
        })


    },
    format,
    getAssessments() {
      let dealership = JSON.parse(localStorage.getItem('selected_dealership'))

      let params = {}

      if (dealership) {
        params = {
          'query[s]': 'updated_at desc',
          'query[dealership_eq]': dealership.name.replace('\'', ''),
          'query[completed_true]': 1,
          'query[report_sections_neq]': '[]',
        }
      } else {
        params = {
          'query[s]': 'updated_at desc',
          'query[dealership_eq]': 'WillNotResolve',
        }
      }

      let query = ApiService.query('api/v1/assessments', { params });

      // console.log(query);

      return query;
    },
    getRecentAssessment() {
      let dealership = JSON.parse(localStorage.getItem('selected_dealership'))

      const params = {
        'query[s]': 'updated_at desc',
        'query[dealership_eq]': dealership.name.replace('\'', ''),
        'query[completed_true]': 1,
        'query[report_sections_neq]': '[]',
        per_page: 1
      };
      return ApiService.query('api/v1/assessments', { params });
    },
    selectGuide(event, data) {
      const button = event.target;
      button.classList.toggle('selected');

      if (button.classList.contains('selected')) {
        if (!this.selectedGuides.includes(data)) {
          this.selectedGuides.push(data)
        }
      } else {
        if (this.selectedGuides.includes(data)) {
          var index = this.selectedGuides.indexOf(data);
          if (index !== -1) {
            this.selectedGuides.splice(index, 1);
          }
        }
      }
    },

    selectDealerTools() {
      var priority = localStorage.getItem('priority');
      if (priority) {

        document.getElementById(`${priority.toLowerCase().replace(/ /g,"_")}_button`).click();
      }
    },
    selectAll() {
      let dealerToolButtons = document.getElementsByClassName("dealer-tool-button");
      for (let i = dealerToolButtons.length - 1; i >= 0; --i){
        if (!dealerToolButtons[i].classList.contains('selected')){
          dealerToolButtons[i].click();
        }
      }
    },
    clearAll() {
      let dealerToolButtons = document.getElementsByClassName("dealer-tool-button");
      for (let i = dealerToolButtons.length - 1; i >= 0; --i){
        if (dealerToolButtons[i].classList.contains('selected')){
          dealerToolButtons[i].click();
        }
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
#export {
  padding: 25px 30px 40px;
  @media (max-width: 576px) {
    padding: 25px 15px 40px;
  }
  .retention-guide-btn {
    @extend .custom-button-inverted;
    font-size: 18px;
    letter-spacing: 1px;
  }
  .action-plan {
    .action-plan-header {
      font-family: FordAntennaCond-Regular, sans-serif;
      text-transform: uppercase;
      color: $fordBlue;
      letter-spacing: 1px;
    }
    .edit-stamp-wrapper {
      background-color: #EEF2F5;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      padding: 5px 15px 0;
      span {
        font-size: 11px;
        letter-spacing: 0;
        color: #5b7886;
      }
    }
    textarea {
      width: 100%;
      height: 200px;
      resize: none;
    }
    .submit-plan-btn {
      @extend .custom-button;
      font-size: 18px;
      letter-spacing: 1px;
      min-width: 250px;
      box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
    }
    .guide-button-container {
      .dealer-tool-button {
        @extend .custom-button;
        color: #263238;
        letter-spacing: .34px;
        background-color: $lightGrey;
        border: 1px solid rgb(124,153,171);
        transition: background-color .5s;
        &:not(last-of-type) {
          margin: 0 10px 10px 0;
        }
        span {
          color: inherit;
          svg {
            color: inherit;
            path {
              color: inherit;
            }
          }
        }
        &:hover {
          background-color: #2861a4;
          color: $white;
          border: 1px solid #2861a4;
        }
        &.selected {
          color: $white;
          background-color: $fordBlue;
          border: 1px solid $fordBlue;
          &:hover {
            background-color: #2861a4;
            border: 1px solid #2861a4;
            color: $white;
          }
        }
      }
    }
    .dealer-actions-container {
      overflow-y: auto;
      //max-height: 580px;
      .dealer-action {
        display: flex;
        flex-direction: row;
        &:not(:last-of-type) {
          border-bottom: 1px solid #c9d6dc;
          padding-bottom: 25px;
          margin-bottom: 25px;
        }
        &:last-of-type {
          padding-bottom: 25px; // Fix clipping issue
        }
        .action-date {
          width: 70px;
          text-align: center;
          span {
            font-size: 12px;
            font-family: FordAntennaCond-Regular, sans-serif;
          }
        }
        .action-details {
          padding-left: 15px;
          width: 90%;
          h6 {
            color: $fordBlue;
            letter-spacing: 0.81px;
            font-size: 13px;
          }
          /deep/ span {
            font-family: FordAntennaCond-Regular, sans-serif;
            letter-spacing: 0.88px;
          }
          /deep/ .collapsed {
            font-family: FordAntennaCond-Regular, sans-serif;
            letter-spacing: 0.88px;
            &::after {
              content: "..."
            }
          }
          /deep/ .more-less-button {
            @extend .link-button;
            border: 0;
            background-color: transparent;
            padding: 1px 0;
          }
        }
      }
    }
  }
}
</style>
